import { FormTemplate } from "components/modal/templates";
import moment from "moment";
import React from "react";
import { apply } from "sources/books/hiredDrivers";
import { config, getConfig, initialState } from "./config";

const uppercaseDocumentFields = new Set(["passportSeries", "passportNumber", "licenseSeries", "licenseNumber"]);

class HiredDriverForm extends FormTemplate {
    getValidationConfig = (state) => getConfig(state);

    setValue = ({ name, value }) => {
        const formattedValue =
            uppercaseDocumentFields.has(name) && typeof value === "string" ? value.toUpperCase() : value;
        const nextState = { ...this.state, [name]: formattedValue };
        const isValid = this.isValidForm(nextState);
        this.setState({ [name]: formattedValue, ...(isValid ? { isValid: true } : {}) });
    };

    sendRequest = (stateData) => {
        const formatted = { ...stateData };
        if (formatted.passportDateOfIssue) {
            formatted.passportDateOfIssue = moment(formatted.passportDateOfIssue).format("YYYY-MM-DD");
        }
        if (formatted.licenseDateOfIssue) {
            formatted.licenseDateOfIssue = moment(formatted.licenseDateOfIssue).format("YYYY-MM-DD");
        }
        if (formatted.licenseExpirationDate) {
            formatted.licenseExpirationDate = moment(formatted.licenseExpirationDate).format("YYYY-MM-DD");
        }
        return apply(formatted);
    };

    renderBodyInner = () => {
        const {
            counterpartyIds,
            lastName,
            firstName,
            patronymic,
            phoneNumber,
            passportIssuingCountry,
            passportSeries,
            passportNumber,
            passportIssuedBy,
            passportDateOfIssue,
            passportSubdivisionCode,
            licenseIssuingCountry,
            licenseSeries,
            licenseNumber,
            licenseDateOfIssue,
            licenseExpirationDate,
        } = getConfig(this.state);
        return (
            <>
                {this.renderSelect(counterpartyIds)}
                {this.renderField(lastName)}
                {this.renderField(firstName)}
                {this.renderField(patronymic)}
                {this.renderField(phoneNumber)}
                <div className="form-group mt-3 mb-2">
                    <strong>Паспортные данные</strong>
                </div>
                {this.renderSelect(passportIssuingCountry)}
                {this.renderField(passportSeries)}
                {this.renderField(passportNumber)}
                {this.renderField(passportIssuedBy)}
                {this.renderDateField(passportDateOfIssue)}
                {this.renderField(passportSubdivisionCode)}
                <div className="form-group mt-3 mb-2">
                    <strong>Водительское удостоверение</strong>
                </div>
                {this.renderSelect(licenseIssuingCountry)}
                {this.renderField(licenseSeries)}
                {this.renderField(licenseNumber)}
                {this.renderDateField(licenseDateOfIssue)}
                {this.renderDateField(licenseExpirationDate)}
            </>
        );
    };
}

const ConfiguredModal = (props) => (
    <HiredDriverForm {...props} config={config} initialState={{ ...initialState, ...(props.data || {}) }} />
);

export default ConfiguredModal;
